import { useQuery } from '@tanstack/react-query'

import axios from '@/_lib/axiosInstance'
import { ApiListResponse, IPriceListPromotion } from '@/_types'

export const fetchPriceListPromotions = async (): Promise<ApiListResponse<IPriceListPromotion>> => {
	return axios
		.get<ApiListResponse<IPriceListPromotion>>(`v1/web/priceListPromo/priceListPromos`)
		.then(res => res.data)
}

export const useGetPriceListPromotions = () => {
	return useQuery<ApiListResponse<IPriceListPromotion>>({
		queryKey: ['price-list-promotions'],
		queryFn: () => fetchPriceListPromotions(),
		select: data => data
	})
}
